import { StringHelpers } from 'helpers/string';
import { Subscribable } from 'knockout';
import { Tag } from 'models/tag';

export default class TopicCommentsFiltersVMTagsGroup {
    private internalTags = ko.observableArray<Tag>([]);

    title: string
    tags: Subscribable<Array<Tag>>

    constructor(public id: string) {
        this.title = StringHelpers.toFirstCharUpperString(id);
        this.tags = this.internalTags.sortBy(t => t.tagValue());
    }

    add(tag: Tag) {
        this.internalTags.push(tag);
    }
}